import Service, { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

import type MatchPaymentModel from 'tio-data/models/match-payment';
import { certifyMatchPaymentsRequest } from 'tio-common/requests/match-payment';

export default class MatchPaymentService extends Service {
  @service declare store: StoreService;

  async certifyMatchPayments(payments: Array<MatchPaymentModel>) {
    const ids = payments.map((p) => p.id).filter((id): id is string => typeof id === 'string');
    const response = await this.store.request(certifyMatchPaymentsRequest(ids));
    const { data } = response.content as { data: unknown };
    // @ts-expect-error - Ember Data pushPayload expects 2 arguments after rollback
    this.store.pushPayload({ data });
  }
}
